import request from "@/utils/request";

export function sendEmail(data) {
  return request({
    url: `/user/contact/submit`,
    method: "post",
    data,
  });
}
